// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lc7R","title":"Header_title__1Kj4n","left":"Header_left__3JgKR","clinicName":"Header_clinicName__2a5nT"};